import { render, staticRenderFns } from "./HomeRouter.vue?vue&type=template&id=e52fe3a6&scoped=true&"
import script from "./HomeRouter.vue?vue&type=script&lang=js&"
export * from "./HomeRouter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e52fe3a6",
  null
  
)

export default component.exports